<template>
  <div class="achievement-list">
    <el-table :data="examInfoList" border style="width: 98%; margin: 0 auto;" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="className" label="班级"> </el-table-column>
      <el-table-column prop="title" label="主标题"> </el-table-column>
      <el-table-column prop="subTitle" label="副标题"> </el-table-column>
      <el-table-column prop="classExamPeople" label="考试人数"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间" width="150"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="150"> </el-table-column>
      <el-table-column prop="schoolYear" label="学年"> </el-table-column>
      <el-table-column prop="semester" label="学期">
        <template slot-scope="scope">
          {{ scope.row.semester == "1" ? "第一学期" : "第二学期" }}
        </template>
      </el-table-column>
      <el-table-column prop="avgScore" label="平均分"> </el-table-column>
      <el-table-column prop="rank" label="排名">
        <template slot-scope="scope">
          {{ scope.row.rank ? scope.row.rank : "无" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400" fixed="right">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="warning" size="small" @click.stop="updateExamClass(scope.row)">修改考试人数 </el-button>
            <el-button type="success" size="small" @click.stop="jumpStudentRank(scope.row)"
              v-hasPermi="'sc:classscore:rank'">学生排行 </el-button>
            <el-button type="success" size="small" @click.stop="viewDimension(scope.row)"
              v-hasPermi="'sc:gradeexam:latitude'">查看维度 </el-button>
            <el-button type="success" size="small" @click.stop="tableShowSwitch(scope.row)"
              v-hasPermi="'sc:gradeexam:latitude'">维度图例 </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- chartType:chartDialog显示类型 -->
    <achievementChartDialog :chartType="'classExam'" :tableData="tableData" v-if="chartDialogShow"
      :chartDialogShow.sync="chartDialogShow" />
    <dimensionTableDialog v-show="dimensionTableShow" :classExamInfo="classExamInfo" :descList="descList"
      :dimensionTableShow.sync="dimensionTableShow" :tableData="tableData" />
    <!-- 修改班级考试人数 -->
    <updateExamClassDialog v-show="updateExamClassDialogShow"
      :updateExamClassDialogShow.sync="updateExamClassDialogShow" :classExamInfo="classExamInfo"
      :examPeople="examPeople" @updateExamClassSuccess="updateExamClassSuccess" />
  </div>
</template>

<script>
import achievementItem from "@/components/achievement-item/achievementItem.vue";
import achievementChartDialog from "../achievement-chart-dialog/achievementChartDialog.vue";
import dimensionTableDialog from "../dimension-table-dialog/dimensionTableDialog.vue";
import updateExamClassDialog from "../update-exam-class-dialog/updateExamClassDialog.vue"
export default {
  props: ["examInfo", "courseFullList", "gradeExamId"],
  components: { achievementItem, achievementChartDialog, dimensionTableDialog, updateExamClassDialog },
  data() {
    return {
      examInfoList: [],
      checkList: [],
      chartDialogShow: false,
      tableData: [],
      descList: [],
      dimensionTableShow: false,
      classExamInfo: {},
      updateExamClassDialogShow: false, // 修改班级考试人数弹窗
      examPeople: '', // 班级考试人数
    };
  },
  created() {
    this.examInfoList = this.examInfo;
  },
  methods: {
    updateExamClassSuccess() {
      let data = {
        id: this.gradeExamId,
      };
      this.get(this.$url.selectClassExamInfoRank, data).then((res) => {
        // console.log("获取班级考试信息==>", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取班级考试信息失败");
        this.examInfoList = res.data;
      });
    },
    updateExamClass(row) {
      let data = {
        examInfoId: row.id,
        classId: row.classId
      };
      this.classExamInfo = row;
      this.get(this.$url.selectExamClassPeople, data).then((res) => {
        if (res.code != 200) return this.$message.error("获取班级考试人数失败");
        this.examPeople = res.data;
        this.updateExamClassDialogShow = true;
      });
    },
    // 跳转学生排行(班级)
    jumpStudentRank(data) {
      this.$router.push({
        path: "/achievement-student-rank",
        query: {
          examType: 'class',
          // classId: data.examInfo.classId,
          // examInfoId: data.examInfo.id,
          examInfo: JSON.stringify(data),
          courseFullList: this.courseFullList,
        },
      });
    },
    handleSelectionChange(e) {
      // 使用filter()方法去除undefined和null
      let filteredArray = e.filter((item) => {
        return item !== undefined && item !== null;
      });

      let classIdArray = [];
      filteredArray.forEach((item) => {
        classIdArray.push(item.classId);
      });

      // console.log("班级考试切换选中==>", filteredArray);

      this.$emit("classAchievementChange", classIdArray);
    },
    // 查看维度图例
    tableShowSwitch(e) {
      // 查询维度数据
      this.getDimensionData(e);
      // 检测数据中是否有指标数据
      const isEveryDescListEmpty = this.tableData.every(
        (item) => item.descList.length === 0
      );

      if (isEveryDescListEmpty) {
        // 所有的 descList 数组都为空
        return this.$message.warning("未录入指标");
      } else {
        // 至少有一个 descList 数组不为空
        this.chartDialogShow = true;
      }
    },
    viewDimension(e) {
      this.classExamInfo = e;
      // 查询维度数据
      this.getDimensionData(e);
      this.dimensionTableShow = true;
    },
    // 查询维度数据
    getDimensionData(e) {
      const data = {
        examInfoId: e.id,
        classId: e.classId,
      };
      this.post(this.$url.selectExamDimensionDetails, data)
        .then((res) => {
          if (res.code !== 200) {
            return;
          }
          this.tableData = res.data;
          this.tableData.forEach((cItem) => {
            cItem.descList.forEach((item) => {
              if (!this.descList.find((dItem) => dItem.desc === item.desc)) {
                this.descList.push(item);
              }
            });
          });
        })
        .catch((error) => {
          // 处理错误
          console.error("Error:", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementList.scss";
</style>